/** Ignore Cmd/Ctrl shortcuts — not Option/Alt (macOS uses Option for é, @, etc.). */
export function shouldIgnoreKeyEvent(e: KeyboardEvent): boolean {
  return e.metaKey || e.ctrlKey;
}

export function isPrintableTypingKey(key: string): boolean {
  return key.length === 1 && key !== 'Dead';
}

/** Match with Unicode normalization (é, æ, ø, å). Case-sensitive when strictCase. */
export function charsMatch(
  typed: string,
  expected: string,
  strictCase = false,
): boolean {
  const t = typed.normalize('NFC');
  const e = expected.normalize('NFC');
  if (strictCase) return t === e;
  return t.toLowerCase() === e.toLowerCase();
}

/** Record key for error stats — preserves case when strict. */
export function errorKeyForChar(char: string, strictCase: boolean): string {
  if (char === ' ') return ' ';
  return strictCase ? char : char.toLowerCase();
}
